module.exports = __webpack_public_path__ + "static/media/union-plus.c12e6242.svg";